  document.addEventListener('DOMContentLoaded', function() {
    const hotspots = document.querySelectorAll('.hotspot__wrapper'); 
    const infos = document.querySelectorAll('.product-info'); 
  
    hotspots.forEach(function(hotspot) {
      hotspot.addEventListener('click', function() {
        const hid = this.dataset.hotspotId;
        
        
        infos.forEach(function(info) {
          info.style.display = 'none';
        });
  
        
        const targetInfo = document.querySelector(`[data-info-id="${hid}"]`);
        if (targetInfo) {
          targetInfo.style.display = 'block';
        }
      });
    });
  });